import { EventEmitter } from './event-emitter';

interface IDirective {
    compile?: any;
    link?: any;
    template?: any;
}

export class Controller extends EventEmitter {
    public static get $name(): string {
        return '';
    }

    public static get $inject(): string[] {
        return [];
    }

    constructor($scope: angular.IScope) {
        super();
        this.clearSubscribesOnDestroy($scope);
    }

    private clearSubscribesOnDestroy($scope: angular.IScope) {
        // remove all event listeners
        $scope &&
            $scope.$on('$destroy', () => {
                this.erase();
            });
    }
}

export abstract class Provider {
    public static get $name(): string {
        return '';
    }

    public static get $getInject(): string[] {
        return [];
    }

    public static get $inject(): string[] {
        return [];
    }

    public abstract $get(...args: any[]): any;
}

export class Service extends EventEmitter {
    public static get $name(): string {
        return '';
    }

    public static get $inject(): string[] {
        return [];
    }
}

export class Directive implements IDirective {
    public static get $templateUrl(): string {
        return '';
    }

    public static get $name(): string {
        return '';
    }

    public static get $inject(): string[] {
        return [];
    }

    public static get $replace(): boolean {
        return false;
    }

    public static get $transclude(): boolean | {} {
        return false;
    }

    public static get $require(): string | {} | string[] {
        return '';
    }

    public static get $controller(): {} | null {
        return null;
    }

    public static get $scope(): {} | boolean {
        return false;
    }

    public static get $priority(): number | null {
        return null;
    }

    public static get $restrict(): boolean | string {
        return false;
    }

    public static get $bindToController(): boolean | { [boundProperty: string]: string } | undefined {
        return false;
    }

    public static get $controllerAs(): string | undefined {
        return '';
    }
}

export abstract class Filter {
    public static get $name(): string {
        return '';
    }

    public static get $inject(): string[] {
        return [];
    }

    public static $get(..._args): any {
        return null;
    }
}
